var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupMenuRemindersOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 12C10.3334 13.2887 9.28875 14.3333 8.00008 14.3333C6.71141 14.3333 5.66675 13.2887 5.66675 12",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8207 12.0003H3.17925C2.52797 12.0003 2 11.4723 2 10.8211C2 10.5083 2.12424 10.2084 2.34539 9.98719L2.74755 9.58506C3.12262 9.20999 3.33333 8.70126 3.33333 8.17086V6.33366C3.33333 3.75633 5.42267 1.66699 8 1.66699C10.5773 1.66699 12.6667 3.75633 12.6667 6.33366V8.17086C12.6667 8.70126 12.8774 9.20999 13.2525 9.58506L13.6546 9.98719C13.8757 10.2084 14 10.5083 14 10.8211C14 11.4723 13.472 12.0003 12.8207 12.0003Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuRemindersOn);
export default __webpack_public_path__ + "static/media/group_menu_reminders_on.f004fb9818545bd1b10a104e0771e2c9.svg";
export { ForwardRef as ReactComponent };